//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoginLayout from '../../layouts/LoginLayout';
import InputText from '../inputs/InputText';
import ApiHelper from '../../helpers/ApiHelper';
import { ClientModel } from '../../models/Client';
import UserService from '../../services/UserService';
import Checkbox from '../inputs/Checkbox';
import { KeyIcon } from 'vue-feather-icons';

export default {
	name: 'RegisterForm',
	components: { Checkbox, InputText, LoginLayout, KeyIcon },
	data() {
		return {
			userService: new UserService(this.$axios),
			apiHelper: new ApiHelper(),
			customer: new ClientModel(),
		};
	},
	methods: {
		async register() {
			const valid = await this.$refs.obs.validate();
			if (valid) {
				this.userService
					.register(this.customer)
					.then((res) => {
						if (res.status === 200) {
							this.$store.commit('setAlert', {
								show: true,
								message:
									'¡Enhorabuena ya estás registrado! Ya puedes hacer tus compras en La Reverde',
								type: 'success',
							});
							this.$auth.setUser(res.data.user);
							this.$auth.setUserToken(res.data.token.token);
							this.$router.push('/');
						}
					})
					.catch((error) => {
						this.apiHelper.handleErrors(error, this.$refs.obs, this.$store);
					});
			}
		},
	},
	mounted() {
		// Esto es para que no sea obligatorio en el registro
		this.customer.addresses_list = null;
	},
};
